var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters, Utils, CustomElementUtils, avoidHandler, Debounce, ViewChild, Components, CommandEvent, CommandEventName, AttributeChangeEventName } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
const UI = UIComponents.UI;
//namespace Pacem.Components.Plus {
export class PacemContextMenuItemElement extends Components.PacemItemElement {
    connectedCallback() {
        super.connectedCallback();
        Utils.addClass(this, PCSS + '-context-menuitem');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        const container = this.container;
        if (container instanceof PacemContextMenuElement) {
            container.refresh();
        }
    }
}
let PacemContextMenuItemCommandElement = class PacemContextMenuItemCommandElement extends PacemContextMenuItemElement {
    createMenuItemElement() {
        const retval = new UI.PacemButtonElement();
        retval.commandArgument = this.commandArgument;
        retval.commandName = this.commandName;
        retval.textContent = this.caption;
        retval.iconGlyph = this.iconGlyph;
        retval.confirmationDialog = this.confirmationDialog;
        retval.confirmationMessage = this.confirmationMessage;
        retval.tooltip = this.tooltip;
        retval.disabled = this.disabled;
        retval.cssClass = this.buttonCssClass;
        return retval;
    }
};
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.String })
], PacemContextMenuItemCommandElement.prototype, "commandName", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.String })
], PacemContextMenuItemCommandElement.prototype, "caption", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.String })
], PacemContextMenuItemCommandElement.prototype, "tooltip", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.String })
], PacemContextMenuItemCommandElement.prototype, "iconGlyph", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.StringArray })
], PacemContextMenuItemCommandElement.prototype, "buttonCssClass", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.String })
], PacemContextMenuItemCommandElement.prototype, "confirmationMessage", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.Element })
], PacemContextMenuItemCommandElement.prototype, "confirmationDialog", void 0);
__decorate([
    Watch({ emit: false, /* important */ reflectBack: true, converter: PropertyConverters.Json })
], PacemContextMenuItemCommandElement.prototype, "commandArgument", void 0);
PacemContextMenuItemCommandElement = __decorate([
    CustomElement({ tagName: P + '-context-menuitem-command' })
], PacemContextMenuItemCommandElement);
export { PacemContextMenuItemCommandElement };
let PacemContextMenuItemSeparatorElement = class PacemContextMenuItemSeparatorElement extends PacemContextMenuItemElement {
    createMenuItemElement() {
        const retval = document.createElement('hr');
        retval.style.pointerEvents = 'none';
        return retval;
    }
};
PacemContextMenuItemSeparatorElement = __decorate([
    CustomElement({ tagName: P + '-context-menuitem-separator' })
], PacemContextMenuItemSeparatorElement);
export { PacemContextMenuItemSeparatorElement };
// <${P}-button class="button-flat ${PCSS}-margin margin-0"><${P}-icon icon="{{ :host.icon || 'more_horiz' }}"></${P}-icon></${P}-button>
let PacemContextMenuElement = class PacemContextMenuElement extends Components.PacemItemsContainerElement {
    constructor() {
        super(...arguments);
        this._dispatchCommand = (e) => {
            avoidHandler(e);
            this._onCommand(new CommandEvent({ commandName: e.detail.commandName, commandArgument: e.detail.commandArgument ?? this.commandArgument }));
        };
        this._slotchangeHandler = (evt) => {
            this._resetLayout();
        };
        this._attributeChangeHandler = (evt) => this._refreshMenuItems;
        this._mouseupHandler = (evt) => {
            const balloon = this._ensureBalloon();
            if (!Utils.isNull(balloon)) {
                balloon.popout();
            }
        };
    }
    validate(item) {
        return item instanceof PacemContextMenuItemElement;
    }
    #btn;
    #icon;
    #balloon;
    _ensureButton() {
        if (!Utils.isNull(this.#btn)) {
            return this.#btn;
        }
        const btnSlot = this._slot;
        if (Utils.isNull(btnSlot)) {
            return null;
        }
        const found = this._lookForAButton();
        if (!Utils.isNull(found)) {
            return this.#btn = found;
        }
        const retval = new UI.PacemButtonElement();
        retval.setAttribute('slot', 'button');
        retval.className = `${PCSS}-margin margin-0 button-flat`;
        const icon = this.#icon = new UI.PacemIconElement();
        retval.appendChild(icon);
        this.appendChild(retval);
        return this.#btn = retval;
    }
    _lookForAButton() {
        const btnSlot = this._slot;
        if (Utils.isNull(btnSlot)) {
            return null;
        }
        const buttons = btnSlot.assignedElements({ flatten: true });
        if (Utils.isNullOrEmpty(buttons)) {
            return null;
        }
        return buttons[0];
    }
    _ensureBalloon() {
        let balloon = this.#balloon;
        if (!Utils.isNull(balloon)) {
            return balloon;
        }
        const shell = CustomElementUtils.findAncestorShell(this);
        if (Utils.isNull(shell)) {
            return null;
        }
        balloon = new UI.PacemBalloonElement();
        balloon.options = { trigger: UI.BalloonTrigger.Click, position: UI.BalloonPosition.HorizontalAuto, align: UI.BalloonAlignment.Auto, autoAdjust: true };
        //balloon.target = this._btn;
        balloon.addEventListener(CommandEventName, this._dispatchCommand, false);
        balloon.className = `${PCSS}-contextmenu`;
        shell.appendChild(balloon);
        return this.#balloon = balloon;
    }
    register(item) {
        const retval = super.register(item);
        if (retval) {
            item.addEventListener(AttributeChangeEventName, this._attributeChangeHandler, false);
            this._refreshMenuItems();
        }
        return retval;
    }
    unregister(item) {
        const retval = super.unregister(item);
        if (retval) {
            item.removeEventListener(AttributeChangeEventName, this._attributeChangeHandler, false);
            this._refreshMenuItems();
        }
        return retval;
    }
    _onCommand(evt) {
        this.dispatchEvent(new CustomEvent(CommandEventName, { detail: evt.detail, cancelable: true, bubbles: true }));
        this.dispatchEvent(new CustomEvent(evt.detail.commandName.toLowerCase(), { detail: evt.detail.commandArgument, cancelable: true, bubbles: true }));
    }
    _resetLayout() {
        const btn = this._ensureButton();
        const balloon = this._ensureBalloon();
        if (!Utils.isNull(btn) && !Utils.isNull(balloon)) {
            balloon.target = btn;
        }
        this._toggleBtn();
        this._toggleIcon();
    }
    _toggleBtn(disabled = this.disabled) {
        const btn = this.#btn;
        if (!Utils.isNull(btn) && btn instanceof Components.PacemElement) {
            btn.disabled = disabled;
        }
    }
    _toggleIcon(icon = this.icon) {
        const iconEl = this.#icon;
        if (!Utils.isNull(iconEl)) {
            iconEl.icon = icon;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._resetLayout();
        this._slot.addEventListener('slotchange', this._slotchangeHandler, false);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'icon':
                    this._toggleIcon(val);
                    break;
                case 'disabled':
                    this._toggleBtn(val);
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeButton();
        this._disposeSlot();
        this._disposeBalloon();
        super.disconnectedCallback();
    }
    refresh() {
        this._refreshMenuItems();
    }
    _disposeButton() {
        this.#btn = this.#icon = null;
    }
    _disposeSlot() {
        const slot = this._slot;
        if (!Utils.isNull(slot)) {
            slot.removeEventListener('slotchange', this._slotchangeHandler, false);
        }
    }
    _disposeBalloon() {
        const balloon = this.#balloon;
        if (!Utils.isNull(balloon)) {
            balloon.removeEventListener(CommandEventName, this._dispatchCommand, false);
            this._disposeBalloonChildren(0);
            balloon.remove();
            this.#balloon = null;
        }
    }
    _disposeBalloonChildren(startAt) {
        const balloon = this.#balloon;
        const count = balloon.children.length;
        for (let j = count - 1; j >= startAt; j--) {
            // cleanup
            const rem = balloon.children.item(j);
            rem.removeEventListener('mouseup', this._mouseupHandler, false);
            rem.remove();
        }
    }
    _refreshMenuItems() {
        const balloon = this._ensureBalloon();
        if (Utils.isNull(balloon)) {
            return;
        }
        const count = balloon.children.length;
        let cursor = 0;
        for (let item of this.items) {
            if (item.hide) {
                continue;
            }
            const menuitem = item.createMenuItemElement();
            menuitem.addEventListener('mouseup', this._mouseupHandler, false);
            if (cursor < count) {
                const repl = balloon.children.item(cursor);
                repl.removeEventListener('mouseup', this._mouseupHandler, false);
                repl.replaceWith(menuitem);
            }
            else {
                balloon.appendChild(menuitem);
            }
            cursor++;
        }
        this._disposeBalloonChildren(cursor);
    }
};
__decorate([
    ViewChild('slot[name=button]')
], PacemContextMenuElement.prototype, "_slot", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemContextMenuElement.prototype, "commandArgument", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContextMenuElement.prototype, "icon", void 0);
__decorate([
    Debounce(true)
], PacemContextMenuElement.prototype, "_refreshMenuItems", null);
PacemContextMenuElement = __decorate([
    CustomElement({
        tagName: P + '-context-menu', shadow: true,
        template: `<slot name="button"></slot><slot></slot>`
    })
], PacemContextMenuElement);
export { PacemContextMenuElement };
